import { countriesStr } from '@/assets/countries';

const state = {
    title: `Short-term Trailer Rental in ${countriesStr('and')}` ,
    description: 'Cost-competitive and flexible trailer rental. Take the hassle out of owning by renting your next trailer with PNO. Get your quote today!',
    image: location.origin + require('@/assets/img/logo_pno_fb.png'),
    imageWidth: 1200,
    imageHeight: 630,
};

const getters = {
};

const actions = {
};

const mutations = {
    title: function (state, payload) { state.title = payload },
    description: function (state, payload) { state.description = payload },
    image: function (state, payload) { state.image = payload },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
